import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useInvoicesList = (page = 1, filters = {}) => useQuery({
    queryKey: ['invoices-list', page, filters],
    queryFn: async () => {
        const params = new URLSearchParams({ page, ...Object.fromEntries(Object.entries(filters).filter(([, v]) => v)) })
        const { data } = await API.get(`/invoices?${params}`)
        return data
    }
})

export default useInvoicesList
